const config = {
  apiUrl: "http://api",
  apiUrlPci: null,
  //  apiUrl: 'http://apps-gateway'
  //  apiUrl: 'https://staging.mvp-sunbit.com'
  features: {

  },
  sampling: {
    "endpoint": "http://localhost:4101/api/v1/sampling",
    "disabled": true,
  },
  launchDarklyClientId: '64a3d3e354eaac132a049129',
};

export default config;



// WEBPACK FOOTER //
// ./src/config/dev.js